import { Phone, Mail, MapPin } from "lucide-react";
import { BrandLockup } from "./Logo";
import Map from "./Map";
import { scrollToId } from "@/lib/scroll";

export default function Footer() {
  return (
    <footer id="contatti" className="bg-[#08090B] border-t border-white/10 pt-20 pb-28 md:pb-12 px-5 sm:px-8 text-[#9CA3AF]" data-testid="footer">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center mb-16">
          <div>
            <h3 className="font-mono text-xs uppercase tracking-[0.25em] text-[#D97736] mb-4">Dove siamo</h3>
            <p className="font-syne font-bold text-2xl sm:text-3xl text-[#F3F4F6] leading-snug mb-4">
              La nostra sede è ad Abbiategrasso, a due passi da Milano.
            </p>
            <p className="text-sm leading-relaxed max-w-md">
              Operiamo in tutta la Lombardia: Milano, Pavia, Lodi, Monza e provincia. Sopralluogo gratuito
              entro 48 ore dalla chiamata.
            </p>
          </div>
          <Map />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          <div>
            <BrandLockup />
            <p className="mt-5 text-sm leading-relaxed max-w-xs">
              Coperture di pregio e impermeabilizzazione avanzata per edilizia civile e industriale in tutta la
              Lombardia.
            </p>
          </div>
          <div>
            <h3 className="font-mono text-xs uppercase tracking-[0.25em] text-[#D97736] mb-5">Contatti</h3>
            <ul className="space-y-3 text-sm">
              <li>
                <a href="tel:+393517479343" data-testid="footer-phone-link" className="flex items-center gap-3 hover:text-[#F3F4F6] transition-colors">
                  <Phone size={15} className="text-[#D97736]" /> +39 351 747 9343
                </a>
              </li>
              <li>
                <a href="mailto:merlo.coperture@yahoo.com" data-testid="footer-email-link" className="flex items-center gap-3 hover:text-[#F3F4F6] transition-colors">
                  <Mail size={15} className="text-[#D97736] shrink-0" /> merlo.coperture@yahoo.com
                </a>
              </li>
              <li className="flex items-center gap-3">
                <MapPin size={15} className="text-[#D97736] shrink-0" /> Via E. Zacconi 11, Abbiategrasso (MI)
              </li>
            </ul>
          </div>
          <div>
            <h3 className="font-mono text-xs uppercase tracking-[0.25em] text-[#D97736] mb-5">Servizi</h3>
            <ul className="space-y-3 text-sm">
              {["Impermeabilizzazione in guaina", "Coperture in tegole", "Pannelli finto coppo coibentati", "Lattoneria e grondaie"].map((s) => (
                <li key={s}>
                  <button onClick={() => scrollToId("#servizi")} className="hover:text-[#F3F4F6] transition-colors">
                    {s}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/5 flex flex-col sm:flex-row justify-between gap-3 text-xs text-[#6B7280] font-mono">
          <p>© {new Date().getFullYear()} MERLO coperture — P.IVA 14270530968</p>
          <p>Cadreghe, colmi e tegole dal 1988.</p>
        </div>
      </div>
    </footer>
  );
}
